export default {
    state: {
        selected_list: [],
        all_data_loaded: false,
    },

    mutations: {
        toggleSelected(state, id) {
            const index = state.selected_list.indexOf(id);

            if (index === -1) {
                state.selected_list.push(id);
            } else {
                state.selected_list.splice(index, 1);
            }
        },

        emptySelected(state) {
            state.selected_list = [];
        },

        setDataLoaded(state) {
            state.all_data_loaded = true;
        },
    },
};
